import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
    mixins: [alertMixins],
    data() {
        return {
            maxPrice: 1000000000,
            maxPriceErrorMsg: ''
        }
    },
    methods: {
        returnNumber(price) {
            if (!util.isEmpty(price)) {
                var regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 선택하는 정규식
                price = String(price).replace(regex, "");
                return util.Number.returnNumber(price);
            } else {
                return 0;
            }
        },
        returnCommas(price) {
            if (!util.isEmpty(price)) {
              
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        returnMaxPrice(price) {
            if (!util.isEmpty(price)) {
                if (util.Number.returnNumber(price) > this.maxPrice) {
                    price = this.maxPrice;
                    this.maxPriceErrorMsg = this.$t('maxPriceErrorMsg', {price: util.Number.numFormat(this.maxPrice)});
                } else {
                    this.maxPriceErrorMsg = '';
                }
                return util.Number.returnNumber(price);
            } else {
                return 0;
            }
        },
    }
}
